module.exports = __webpack_public_path__ + "img/Blood-Filled_Vial.18d978d2.png";